export enum ProductTags {
  ACTIVITY = 'activity',
  ETA = 'mkpl_eta',
  SHIPS_FROM = 'ships_from',
  WEEKLY_SOLD = 'weekly_sold',
  LEFT = 'left',
  RANKING = 'ranking',
  /** 预售：预送日期label */
  PRE_SALE = 'pre_sale',
  /** mof 预计送达日期label */
  DELIVERY_DATE = 'delivery_date'
}

export enum ProductLabelKeyEnum {
  PRESALE = 'presale', // 预售
  WEEK_FEATURED = 'week_featured', // 每周一品
  OFF = 'off', // 折扣
  NEW = 'new', // 新品
  LIMITED = 'limited', // 限购
  CHEF_PICK = 'chef_pick' // 主厨推荐
}
